// 上报 SDK 地址
export const REPORT_SDK_URL = 'https://static.wetvinfo.com/libs/wetv-report-sdk/last/wetv-report-sdk.js';

// 上报 SDK 实例名称
export const REPORT_INSTANCE_NAME = 'wetvReport';

// 页面暂停上报事件名
export const PAGE_HOLD_EVENT = 'dtPageHold';

// 默认路由类型
export const DEFAULT_ROUTER_TYPE = 'hash';

// 页面容器元素 ID
export const PAGE_CONTAINER_ID = 'wetv-page';
